import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { LoggerService } from './logger.service';

@Injectable({ providedIn: 'root' })
export class LoggerRouteTracker implements OnDestroy {
  private sub?: Subscription;
  private previous: string | null = null;

  constructor(private router: Router, private logger: LoggerService) {}

  start(): void {
    if (this.sub) return;
    this.sub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        const next = e.urlAfterRedirects;
        const from = this.previous;
        this.previous = next;
        if (from === null) {
          this.logger.info('app.route.initial', { to: next });
          return;
        }
        if (from === next) return;
        this.logger.info('app.route.changed', { from, to: next });
      });
  }

  ngOnDestroy(): void { this.sub?.unsubscribe(); }
}
